import React from "react";
import { AttendingEventType } from "store/attendingEvents/attendingEvents.types";
import * as S from "./index.styles";

interface EventStatusBadgeProps {
  type: AttendingEventType;
}

const EventStatusBadge: React.FC<EventStatusBadgeProps> = ({ type }) => {
  return <S.StatusBadge type={type}>{type}</S.StatusBadge>;
};

export default EventStatusBadge; 